import React from 'react';
import styles from './correspondenceListItemSkeleton.module.scss';
import {RectSkeleton} from 'app/views/components/skeleton';

export const CorrespondenceListItemSkeleton = () => (
    <div className={styles.skeleton}>
        <div className={styles.info}>
            <RectSkeleton width={170} />
        </div>
        <div className={styles.info}>
            <RectSkeleton width={100} />
        </div>
        <div className={styles.info}>
            <RectSkeleton width={226} />
        </div>
        <div className={styles.info}>
            <RectSkeleton width={144} />
        </div>
    </div>
);
